import { query, where, getDocs } from "firebase/firestore";
import {
  fetchAll,
  createDocWithId,
  updateDocById,
  deleteDocById,
  collRef,
  isSandboxMode,
} from "./firestoreHelpers";

const COLL = "alquileres_liquidaciones";

// Each entry: { idFirebase, locadorId, locadorNombre, mes, anio, montoPagado, fechaPago, observaciones }
export const getLiquidaciones = async () => fetchAll(COLL);

// Devuelve TODAS las liquidaciones de un locador/mes/anio. Consciente del modo
// Sandbox (donde una query directa a Firestore no ve los datos locales).
const findLiquidacionesByLocadorMes = async (locadorId, mes, anio) => {
  if (isSandboxMode()) {
    const all = await fetchAll(COLL);
    return all.filter((l) => l.locadorId === locadorId && l.mes === mes && l.anio === anio);
  }
  const q = query(
    collRef(COLL),
    where("locadorId", "==", locadorId),
    where("mes", "==", mes),
    where("anio", "==", anio)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ idFirebase: d.id, ...d.data() }));
};

export const getLiquidacionByLocadorMes = async (locadorId, mes, anio) => {
  const found = await findLiquidacionesByLocadorMes(locadorId, mes, anio);
  return found[0] || null;
};

// Upsert: if a liquidacion already exists for the same locador/mes/anio, update it.
export const saveLiquidacion = async (data) => {
  const existing = await getLiquidacionByLocadorMes(data.locadorId, data.mes, data.anio);
  if (existing) {
    await updateDocById(COLL, existing.idFirebase, data);
    return existing.idFirebase;
  }
  return createDocWithId(COLL, data);
};

export const deleteLiquidacion = async (id) => deleteDocById(COLL, id);

// Borra TODAS las liquidaciones de un locador/mes/anio (robusto ante duplicados).
export const deleteLiquidacionesDeLocadorMes = async (locadorId, mes, anio) => {
  const found = await findLiquidacionesByLocadorMes(locadorId, mes, anio);
  await Promise.all(found.map((l) => deleteDocById(COLL, l.idFirebase)));
};
